import rgb2hex from './rgb-to-hex';
import hsl2rgb from './hsl-to-rgb';

const hsl2hex = (hslColor) => rgb2hex(hsl2rgb(hslColor));

export default hsl2hex;
